import { render, staticRenderFns } from "./aspect-tiles-component.vue?vue&type=template&id=166af562&scoped=true&"
import script from "./aspect-tiles-component.vue?vue&type=script&lang=ts&"
export * from "./aspect-tiles-component.vue?vue&type=script&lang=ts&"
import style0 from "./aspect-tiles-component.vue?vue&type=style&index=0&id=166af562&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166af562",
  null
  
)

export default component.exports